import { Dialog } from "components/ui";
import React, { useState } from "react";

const ImagePreview = ({ imageData, setImageData }) => {
  const [index, setIndex] = useState(0);

  return (
    <Dialog
      width={720}
      isOpen={imageData.show}
      onClose={() => {
        setImageData({
          show: false,
          images: [],
          title: "",
        });
      }}
      onRequestClose={() => {
        setImageData({
          show: false,
          images: [],
          title: "",
        });
      }}
    >
      <h5 className="mb-4">{`Image Preview ${
        imageData.title !== "" && " - " + imageData.title
      }`}</h5>
      <div className="p-4">
        <div className="flex flex-row justify-center">
          <img
            style={{
              height: `calc(40vh)`,
            }}
            className="mb-2"
            src={imageData.images?.[index]}
            alt="highlight"
          />
        </div>
        <div className="bg-gray-200 p-2 flex flex-row justify-center items-center space-x-1 w-full overflow-x-auto">
          {imageData.images?.map((i, idx) => {
            return (
              <button
                key={idx}
                onClick={() => {
                  setIndex(idx);
                }}
              >
                <img
                  className={`w-[160px] aspect-[4/3] ${
                    idx === index && "border-2 border-red-400"
                  }`}
                  src={i}
                  alt="random"
                />
              </button>
            );
          })}
        </div>
      </div>
    </Dialog>
  );
};

export default ImagePreview;
